import React from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle
} from 'reactstrap'
import Monetario from './Monetario'

const ValoresCard = ({ titulo, valor, icone, cor }) => {
  return (
    <Col lg="3" md="6" sm="6">
      <Card className="card-stats">
        <CardBody className="card-valores">
          <Row>
            <Col md="3" className="p-0">
              <div className="icon-big text-center icon-warning">
                <i className={`fas ${cor} ${icone}`} />
              </div>
            </Col>
            <Col md="9" className="pl-0">
              <div className="numbers card-valor">
                <p className="card-category">{titulo}</p>
                {/* <CardTitle className="m-0"><Monetario valor={valor} /></CardTitle> */}
                <CardTitle className="m-0">R$ {valor}</CardTitle>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const ValoresCard_g = ({ titulo, valor, icone, cor }) => {
  return (
    <Col lg="6" md="8" sm="8">
      <Card className="card-stats">
        <CardBody className="card-valores">
          <Row>
            <Col md="3" className="p-0">
              <div className="icon-big text-center icon-warning">
                <i className={`fas ${cor} ${icone}`} />
              </div>
            </Col>
            <Col md="9" className="pl-0">
              <div className="numbers card-valor">
                <p className="card-category">{titulo}</p>
                {/* <CardTitle className="m-0"><Monetario valor={valor} /></CardTitle> */}
                <CardTitle className="m-0">R$ {valor}</CardTitle>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ValoresCard
